import { HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { delay, of, switchMap } from 'rxjs'

export const artificialDelayInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    switchMap((res) => {
      if (res instanceof HttpResponse) {
        const delayMs = Number(res.headers.get('X-ARTIFICIAL-DELAY')) || 0
        if (delayMs > 0) {
          return of(res).pipe(delay(Math.min(delayMs, 5000))) // Cap the delay to 5 seconds to avoid excessively long waits
        }
      }
      return of(res)
    }),
  )
}
